import React from "react";
import type { Theme } from "@mui/material/styles";

export const getTextColorStyle = (theme: Theme): React.CSSProperties => ({
  color: theme.palette.primary.main,
});
